/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument } from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument';
import {
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSONTyped,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON,
} from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import type { MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner } from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner';
import {
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerFromJSON,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerFromJSONTyped,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerToJSON,
} from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInner
 */
export interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInner {
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInner
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInner
     */
    connector_document_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInner
     */
    processing_error?: string;
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInner
     */
    created_by_user?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser;
    /**
     * 
     * @type {CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInner
     */
    external_ehr_document?: CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument;
    /**
     * 
     * @type {Array<MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner>}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInner
     */
    errors?: Array<MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner>;
}

/**
 * Check if a given object implements the MatrixCarePatientDetailsDocumentsScreenerDocumentsInner interface.
 */
export function instanceOfMatrixCarePatientDetailsDocumentsScreenerDocumentsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSON(json: any): MatrixCarePatientDetailsDocumentsScreenerDocumentsInner {
    return MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsDocumentsScreenerDocumentsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        'connector_document_id': !exists(json, 'connector_document_id') ? undefined : json['connector_document_id'],
        'processing_error': !exists(json, 'processing_error') ? undefined : json['processing_error'],
        'created_by_user': !exists(json, 'created_by_user') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON(json['created_by_user']),
        'external_ehr_document': !exists(json, 'external_ehr_document') ? undefined : CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON(json['external_ehr_document']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerFromJSON)),
    };
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerToJSON(value?: MatrixCarePatientDetailsDocumentsScreenerDocumentsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        's3_key': value.s3_key,
        'connector_document_id': value.connector_document_id,
        'processing_error': value.processing_error,
        'created_by_user': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON(value.created_by_user),
        'external_ehr_document': CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON(value.external_ehr_document),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerToJSON)),
    };
}

